import styled from '@emotion/styled'
import { V2L2DashboardListItem, V2L2DashboardListItemRootProps } from "./V2L2DashboardListItem"
import { appointmentDurationMinutes, appointmentIsOnDay, dateAndDowShort, StatusedAppointment } from '@fusion-advantage/formlib'
import { FusionColor } from '../../../../theme/FusionStyle'
import { useMemo } from 'react'
import { apptListGridline, ApptListHourSpacingUnits } from './ApptList'
import { DateTime } from 'luxon'

interface V2L2ApptListItemBaseProps extends V2L2DashboardListItemRootProps {
	gridRowStart: string
	marginStartUnits: number
	heightUnits: number
}

const V2L2ApptListItemBase = styled(V2L2DashboardListItem)<V2L2ApptListItemBaseProps>(({
	gridRowStart,
	marginStartUnits,
	heightUnits,
}) => ({
	gridColumn: '2/-1',
	gridRowStart,
	marginLeft: '1rem',
	marginRight: '1rem',
	// adjust by 2px so that grid lines show through
	marginTop: `calc(${(1 + marginStartUnits)/2}rem + 2px)`,
	height: `calc(${heightUnits/2}rem - 2px)`,
}))

interface V2L2ApptListItemProps {
	statusedItem: StatusedAppointment
	active: boolean
	onClick?: React.MouseEventHandler<HTMLButtonElement>
	listDisplayDate: string
}

export const V2L2ApptListItem = ({statusedItem, active, onClick, listDisplayDate}: V2L2ApptListItemProps) => {
	const appt = statusedItem.item
	const { subtitle, props } = useMemo(() => {
		const start = DateTime.fromISO(appt.StartTime).toLocal()
		const end = DateTime.fromISO(appt.EndTime).toLocal()
		const startH = start.hour
		const startM = start.minute
		const durationM = appointmentDurationMinutes(appt)
		// show the date, if the date is not the date in question
		const isOnDisplayDate = appointmentIsOnDay(appt, listDisplayDate)
		const day = isOnDisplayDate ? '' : '[' + dateAndDowShort(start) + '] '
		const startTime = start.toFormat('t')
		const endTime = end.toFormat('t')
		return {
			subtitle: day + `${startTime} - ${endTime}`,
			props: {
				gridRowStart: String(apptListGridline(startH)),
				marginStartUnits: (startM > 0) ? ((startM / 60) * ApptListHourSpacingUnits) : 0,
				heightUnits: (durationM > 0) ? ((durationM / 60) * ApptListHourSpacingUnits) : 10,
			},
		}
	}, [appt, listDisplayDate])
	return (
		<V2L2ApptListItemBase
			status={statusedItem.status}
			active={active}
			activeColor={FusionColor.BlueMain}
			onClick={onClick}
			title={appt.MemberName}
			subtitle={subtitle}
			id={`[${appt.AppointmentNumber}]`}
			{...props}
		/>
	)
}
